<template>
  <div class="side-con">
    <router-link v-for="item in items" 
      :key="item.id" 
      :to="targetLink(item)" 
      :class="['side-con-item', {'active': item.id == activeIndex}]">
      <img class="side-image" :src="item.active" v-if="item.active && item.id == activeIndex" :alt="item.name" width="30" height="50"/>
      <img class="side-image" :src="item.image" v-else-if="item.image" :alt="item.name" width="30" height="50"/>
      <span class="material-icons side-icon" v-else-if="item.icon">{{ item.icon }}</span>
      <span class="side-label desktop">{{ item.desktopTitle }}</span>
      <span class="side-label mobile">{{ item.mobileTitle }}</span>
    </router-link>
  </div>
</template>
<script>
import utility from "@/presentation/mixins/utility.js";
import faqIcon from "@/assets/icons/faq.png";
import faqActiveIcon from "@/assets/icons/faq-active.png";
import signalIcon from "@/assets/icons/signal.png";
import signalActiveIcon from "@/assets/icons/signal-active.png";
import peakPursuits from "@/assets/icons/peak-pursuits.png";
import peakPursuitsActive from "@/assets/icons/peak-pursuits-active.png";
import adventuresIcon from "@/assets/icons/adventures-icon.png";
export default {
  name: "BaseSideNav",
  mixins: [utility],
  props: {
    activeIndex: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      items: [
        {
          id: 1,
          desktopTitle: "Home",
          mobileTitle: "Home",
          icon: "",
          image: peakPursuits,
          active: peakPursuitsActive,
          link: "/"
        },
        {
          id: 2,
          desktopTitle: "Adventures & Activities",
          mobileTitle: "Adventures",
          icon: "person",
          image: adventuresIcon,
          active: adventuresIcon,
          link: "/events"
        },
        {
          id: 3,
          desktopTitle: "Expert Guides",
          mobileTitle: "Expert Guides",
          icon: "volcano",
          image: signalIcon,
          active: signalActiveIcon,
          link: '/expert-guides',
        },
        {
          id: 4,
          desktopTitle: "F.A.Q.",
          mobileTitle: "F.A.Q.",
          icon: "contact_support",
          image: faqIcon,
          active: faqActiveIcon,
          link: "/faq"
        },
      ]
    }
  },
  computed: {
    shopLink() {
      let apiCode = this.$route.params.outlet;
      if (!apiCode) {
        let outlet = this.$store.getters.getCurrentOutlet;
        apiCode = outlet.apiCode;
      }
      return `/shop/${apiCode}`;
    },
  },
  methods: {
    targetLink(item) {
      // if (item.id == 2) return this.shopLink;
      return item.link;
    }
  }
}
</script>
<style scoped lang="scss">
.side-con {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}
.side-con-item {
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 2px;
  &:hover {
    .side-icon {
      color: $secondary-color-80;
    }
  }
  .side-image {
    object-fit: contain;
    width: 30px;
    height: 50px;
    filter: grayscale(1);
    opacity: 0.35;
  }
  .side-icon {
    padding: 4px 16px;
    border-radius: 24px;
    color: rgba(46, 38, 61, 0.4);
    font-size: 2.5em;
  }
  .side-label {
    color: $secondary-color-60;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    font-weight: 600;
    color: rgba(46, 38, 61, 0.4);
    &.desktop {
      display: none;
    }
  }
  &.active {
    .side-image {
      filter: grayscale(0) !important;
      opacity: 1 !important;
    }
    .side-icon {
      color: $green-light;
      // color: rgba(64, 64, 64, 1);
    }
    .side-label {
      color: rgba(64, 64, 64, 1);
    }
  }
}
@media (max-width: 672px) {
  .side-con-item {
    justify-content: flex-start !important;
  }
  .side-label {
    max-width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
@media (min-width: 672px) {
  .side-con {
    flex-direction: column !important;
    height: calc(100% - 70px);
    gap: 48px !important;
    justify-content: center !important;
    align-items: center;
    position: fixed;
    margin-block: auto;
    left: 0;
    top: 0;
    bottom: 0;
    max-width: 80px;
  }
  .side-con-item {
    &.active {
      .side-label {
        margin-top: 4px;
      }
    }
  }
  .side-label {
    &.desktop {
      display: block !important;
    }
    &.mobile {
      display: none !important;
    }
  }
}
@media (max-height: 600px) {
  .side-con {
    gap: 20px !important;
    top: auto !important;
    bottom: auto !important;
    justify-content: flex-start !important;
    max-height: calc(100vh - 70px);
    overflow: hidden;
    overflow-y: auto;
  }
}
</style>